<template>
  <div>
    <div v-if="formsResultsView" class="col-12 bg-white p-4 float-left forms-results-view">
      <div class="print_hide" style="background-color: #e8f4f9;padding: 15px;padding-bottom: 0;">
        <b-row>
          <h4 class="pl-2">{{$t('Filters')}}</h4>
        </b-row>
        <b-row>
          <b-col lg="6" class="my-1">
            <b-form-group
              :label="$t('Form')"
              label-for="name-input">
              <!--<b-form-radio-group-->
              <!--v-model="formFilters.formId"-->
              <!--:options="formsOptions"-->
              <!--name="buttons-01"-->
              <!--buttons-->
              <!--button-variant="white"-->
              <!--@change="clearResults()"-->
              <!--:state="$v.formFilters.formId.$dirty ? !$v.formFilters.formId.$error : null"-->
              <!--&gt;-->

              <!--</b-form-radio-group>-->
              <b-form-select
                v-model="formFilters.formId"
                :options="formsOptions"
              ></b-form-select>
              <!--<div v-show="$v.formFilters.formId.$error" class="text-danger"> {{$t('This is a required field.')}}</div>-->
            </b-form-group>
          </b-col>
          <!--<b-col lg="3" class="my-1">-->
          <!--<b-form-group-->
          <!--:label="$t('Select Users')"-->
          <!--label-for="name-input"-->
          <!--&gt;-->
          <!--<multiselect v-model="formFilters.users" :groupSelect="true" :optionHeight="10" :showLabels="false" deselectLabel="" selectLabel="" :options="usersOptions" :multiple="true" :close-on-select="false" :searchable="false" :clear-on-select="false" group-label="groupName" group-values="users" :taggable="false" :preserve-search="false" :placeholder="$t('Select User')" label="text" track-by="value" :preselect-first="false">-->
          <!--&lt;!&ndash;<template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>&ndash;&gt;-->
          <!--</multiselect>-->
          <!--&lt;!&ndash;<b-form-select size="sm" v-model="filters.users" :options="usersOptions"></b-form-select>&ndash;&gt;-->
          <!--</b-form-group>-->
          <!--</b-col>-->
          <b-col lg="4" class="my-1">
            <b-form-group
              :label="$t('Date Range')"
              label-for="name-input"
            >
              <v-date-picker
                mode='range'
                v-model="formFilters.dateRange"
                show-caps
                :max-date='new Date()'
              >
              </v-date-picker>
              <button
                type="button"
                class="bg-white custom-calendar-clear"
                @click="formFilters.dateRange = null">
                Clear
              </button>
              <!--<div v-show="$v.formFilters.dateRange.$error" class="text-danger"> {{$t('This is a required field.')}}</div>-->

            </b-form-group>
          </b-col>
          <b-col lg="4" class="my-1">
            <b-form-group
              :label="$t('Tag')"
              label-for="name-input">
                <b-form-input
                  v-model="formFilters.tag"
                  type="search"
                  :placeholder="$t('Tag Search')"
                ></b-form-input>
              <!--<div v-show="$v.formFilters.formId.$error" class="text-danger"> {{$t('This is a required field.')}}</div>-->
            </b-form-group>
          </b-col>
          <b-col lg="4" class="my-1">
            <b-form-group
              :label="$t('Open by')"
              label-for="name-input">
              <b-form-select
                v-model="formFilters.createdByUserId"
                :options="usersOptions"
              ></b-form-select>
<!--              <b-form-select-->
<!--                v-model="formFilters.openBy"-->
<!--                :options="usersOptions"-->
<!--              ></b-form-select>-->
              <!--<div v-show="$v.formFilters.formId.$error" class="text-danger"> {{$t('This is a required field.')}}</div>-->
            </b-form-group>
          </b-col>
          <b-col lg="12" class="my-1">

            <b-btn style="float:right;color:white;margin-bottom: 15px; margin-top: 22px;" variant="light" @click="searchForms(true)"><i class="fa fa-search"></i>{{$t('Search')}}</b-btn>
                     </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-btn v-show="formsResults.length > 0" style="float:right;color:white;margin-bottom: 15px; margin-top: 22px;" variant="light" @click="prePrintAll()"><i class="fa fa-print"></i>{{$t('Export PDF')}}</b-btn>
            <b-btn v-show="formsResults.length > 0" style="float:right;color:white;margin-bottom: 15px; margin-top: 22px;margin-right: 5px" variant="light" @click="exportExcel()"><i class="fa fa-file-excel-o"></i>{{$t('Export Excel')}}</b-btn>
          </b-col>

        </b-row>
        <b-row>
          <b-col>
          <label style="float:right;" class="font-weight-bold font-italic">* {{$t("Export is based on filters not results")}} </label>
          </b-col>
        </b-row>
      </div>

      <b-table
        show-empty
        hover
        responsive
        :items="formsResults"
        :fields="formResultFields"
        :current-page="currentFormResultPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="formResultFieldsSortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :sort-compare="customCompare"
        @filtered="onFiltered"
      >
        <template v-slot:empty="scope">
          <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
        </template>
        <template v-slot:cell(formName)="row">
          <div class="font-weight-bolder d-inline" > {{row.item.formName}}  </div>
<!--          <div class="d-inline" v-if="row.item.hasOwnProperty('tag') && row.item.tag != null">({{row.item.tag}})</div>-->
        </template>

        <!--<template v-slot:cell(name)="row">-->
        <!--<b-link class="nav-link no-padding" :to="'/users/'+row.item.id"> {{ row.item.firstName }} {{ row.item.lastName }} </b-link>-->
        <!--</template>-->

        <template v-slot:cell(status)="row">
          <label :class="row.item.status === 'COMPLETED' ? ' badge badge-success' : 'badge badge-light'" style="text-align: center;">{{ $t(row.item.status) }}</label>
        </template>

        <template v-slot:cell(actions)="row" >
          <b-button variant="outline-light" size="sm" @click="prePrint(row.item)">
            <i class="fa fa-print" style="margin:0"></i>
          </b-button>
          <b-button variant="outline-light" size="sm" @click="exportExcel(row.item)">
            <i class="fa fa-file-excel-o" style="margin:0"></i>
          </b-button>
          <b-button variant="outline-light" size="sm" @click="showReport(row.item)">
            {{$t('Show Report')}}
          </b-button>
        </template>
      </b-table>
      <b-pagination
        v-model="currentFormResultPage"
        :total-rows="totalFormResultRows"
        :per-page="perPage"
        align="center"
        class="my-5"
      ></b-pagination>
    </div>
    <form-result v-else
                 v-bind:formsResultsView="formsResultsView"
                 v-on:update:formsResultsView="formsResultsView = $event" :formResult="reportForm"></form-result>
  </div>
</template>

<script>
import moment from 'moment'
import FormResult from './FormResult'

export default {
  name: 'FormResults',
  components: {FormResult},
  props: {
    'group': {
      type: Object,
      default: {}
    },
    'category': {
      type: Object,
      default: {}
    },
    'users': {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      usersOptions: [],
      reportForm: {},
      forms: [],
      startDateFormatted: null,
      endDateFormatted: null,
      hideForForms: false,
      massReportRows: [],
      perPage: 20,
      sortDirection: 'asc',
      sortDesc: false,
      form: {
        companyId: null,
        groupId: this.$route.params.id,
        user: null
      },
      formResultFieldsSortBy: 'createdAt',
      currentFormResultPage: 1,
      totalFormResultRows: 0,
      filterOn: [],
      filter: null,
      formsResultsView: true,
      formFilters: {
        dateRange: null,
        formId: null,
        tag: null,
        createdByUserId: null
      },
      formsResults: [],
      formsOptions: [{text: this.$t('Select Form'), value: null}]
    }
  },
  validations: {
    formFilters: {
    }
  },
  computed: {
    formResultFields () {
      var aFields = []
      aFields.push({ key: 'formName', label: this.$t('Title'), sortable: true })
      aFields.push({ key: 'tag', label: this.$t('Tag'), sortable: true })
      aFields.push({ key: 'createdByDisplayName', label: this.$t('Open by'), sortable: true })
      aFields.push({ key: 'status', label: this.$t('Status'), sortable: true })
      aFields.push({ key: 'formDayFormatted', label: this.$t('Form day'), sortable: true, class: 'text-center' })
      aFields.push({ key: 'completedAt', label: this.$t('Completed at'), sortable: true, class: 'text-center' })
      aFields.push({ key: 'completedByUserName', label: this.$t('Completed by'), sortable: true })
      aFields.push({ key: 'actions', label: this.$t('Actions'), class: 'text-center' })
      return aFields
    }
  },
  mounted () {
    if (this.$route.params.company) {
      this.form.companyId = this.$route.params.company
    } else {
      this.form.companyId = this.$store.state.user.data.companyId
    }
    this.fetchForms()

    this.usersOptions = [{text: this.$t('Select User'), value: null}]
    this.users.forEach(user => {
      this.usersOptions.push({text: user.firstName + ' ' + user.firstName, value: user.id})
    }, this)
  },
  methods: {
    fetchForms () {
      var self = this
      this.formsOptions = [{text: this.$t('Select Form'), value: null}]
      if (self.forms.length > 0) {
        self.forms.forEach(function (form) {
          self.formsOptions.push({value: form.id, text: form.name})
        })
        return
      }
      this.$firebase.firestore().collection('companies').doc(this.form.companyId).collection('groups').doc(this.$route.params.id).collection('forms').where('status', 'in', ['Active', 'Inactive']).orderBy('priority', 'asc').get().then(function (forms) {
        self.forms = []
        console.log('forms', forms)
        forms.forEach(function (form) {
          console.log('form', form.data())
          var formData = form.data()
          formData.id = form.id
          if (formData.createdAt != null) {
            formData.createdAt = moment(String(formData.createdAt.toDate())).format('DD/MM/YYYY hh:mm')
          }
          if (formData.updatedAt != null) {
            formData.updatedAtFormatted = moment(String(formData.updatedAt.toDate())).format('DD/MM/YYYY kk:mm')
          }
          self.forms.push(formData)
          self.formsOptions.push({value: form.id, text: formData.name})
        })
      })
    },
    prePrint (item) {
      var data = {}

      data.groupId = this.$route.params.id
      if (this.$route.params.company != null) {
        data.companyId = this.$route.params.company
      } else {
        data.companyId = this.$store.state.user.data.companyId
      }
      data.filters = JSON.parse(JSON.stringify(this.formFilters))
      console.log('itemmmm', item)
      data.formResultId = item.id
      data.formId = item.formId

      data.filters = JSON.stringify(data.filters)
      console.log('dataaaa', data)
      window.open(this.$firebase.app().options.functionsHostName + '/downloadFormResults?' + new URLSearchParams(data))
    },
    exportExcel (item) {
      if (!item && (this.formFilters.dateRange === null || this.formFilters.formId === null)) {
        this.$swal({
          title: this.$t('Warning!'),
          text: this.$t('In order to export in excel you need to select a specific date range and form'),
          type: 'info',
          timer: 0,
          showConfirmButton: true
        })
        return
      }
      var data = {}

      data.groupId = this.$route.params.id
      if (this.$route.params.company != null) {
        data.companyId = this.$route.params.company
      } else {
        data.companyId = this.$store.state.user.data.companyId
      }
      data.filters = JSON.parse(JSON.stringify(this.formFilters))
      console.log('itemmmm', item)
      if (item) {
        data.formResultId = item.id
        data.formId = item.formId
      }
      data.filters = JSON.stringify(data.filters)
      console.log('dataaaa', data)
      window.open(this.$firebase.app().options.functionsHostName + '/exportExcelFormResults?' + new URLSearchParams(data))
    },
    showReport (item, mass) {
      // construct array
      var self = this
      self.reportForm = item
      // var reportRows = []
      // console.log('itemmmmmm=====', item)
      // this.reportName = item.name
      // this.reportDate = moment(String(item.createdAt.toDate())).format('dddd DD/MM/YYYY')
      // // var sorted = item.results.sort(self.compare)
      // for (var i = 0; i < item.template.length; i++) {
      //   // console.log('indexxxxxxxx', i)
      //   var index = item.template.findIndex(v => v.order === i + 1)
      //   if (index !== -1) {
      //     var element = item.template[index]
      //     // debugger
      //     element['results'] = []
      //     element['date'] = moment(String(item.createdAt.toDate())).format('dddd DD/MM/YYYY')
      //     // var submissionId = null
      //     // console.log(item)
      //     item.results.forEach(function (result) {
      //       var resultObj = {...result}
      //       // console.log('result', result)
      //       // console.log('resultObj', resultObj)
      //       // if (submissionId === result.submissionId || submissionId == null)
      //       // console.log('checksss======', result.order + '===' + element.order)
      //       if (resultObj.order === element.order) {
      //         console.log('in with', resultObj)
      //         switch (resultObj.type) {
      //           case 'TEMPERATURE':
      //             resultObj.value = resultObj.value + ' ℃'
      //             break
      //           case 'CHECKBOX':
      //             resultObj.value = resultObj.value === true ? '<i class="fa fa-check"></i>' : '<i class="fa fa-times"></i>'
      //             break
      //           case 'WEIGHT':
      //             resultObj.value = resultObj.value + ' kg'
      //             break
      //           default:
      //             break
      //         }
      //         resultObj.recordedAt = moment(String(resultObj.recordedAt.toDate())).format('DD/MM HH:mm')
      //         // console.log('recorded', result.recordedAt)
      //         // console.log('recorded String =  = = =', result.recordedAt.toString())
      //
      //         // console.log('companyUserss===', self.users)
      //         var user = self.users.find(u => u.id === resultObj.userId)
      //         if (user) {
      //           resultObj.userName = user.firstName + ' ' + user.lastName
      //         }
      //         element['results'].push(resultObj)
      //       }
      //     })
      //     reportRows.push(element)
      //   }
      // }
      // var objectReportRows = {}
      // console.log('created at', moment(String(item.createdAt.toDate())).format('dddd DD/MM/YYYY'))
      // objectReportRows['date'] = moment(String(item.createdAt.toDate())).format('dddd DD/MM/YYYY')
      // objectReportRows['name'] = item.name
      // objectReportRows['data'] = reportRows

      // if (mass) {
      //   this.massReportRows.push(objectReportRows)
      // } else {
      //   this.massReportRows = []
      //   this.massReportRows.push(objectReportRows)
      // }
      //
      // console.log('this.objectReportRows', objectReportRows)
      this.formsResultsView = false
    },
    customCompare (a, b, key) {
      if (['date', 'time', 'dateIn', 'dateOut', 'createdAt', 'createdAtFormatted', 'updatedAtFormatted'].includes(key)) {
        var aDate = moment(a[key], 'DD/MM/YYYY kk:mm')
        var bDate = moment(b[key], 'DD/MM/YYYY kk:mm')
        if (aDate.isValid && bDate.isValid) {
          if (aDate < bDate) {
            return -1
          } else if (aDate > bDate) {
            return 1
          } else {
            return 0
          }
        }
        return null
      } else {
        // Let b-table handle sorting other fields (other than `date` field)
        return false
      }
    },
    searchForms (clear) {
      var self = this
      var data = {}

      this.$v.formFilters.$touch()
      if (this.$v.formFilters.$anyError) {
        return
      }

      this.loadMoreBool = true
      if (clear) {
        this.formsResults = []
      }

      // for printing purposes
      if (this.formFilters.dateRange != null) {
        this.startDateFormatted = moment(new Date(this.formFilters.dateRange.start).toString()).format('DD/MM/YYYY')
      } else {
        this.startDateFormatted = null
      }
      if (this.formFilters.dateRange != null) {
        this.endDateFormatted = moment(new Date(this.formFilters.dateRange.end).toString()).format('DD/MM/YYYY')
      } else {
        this.endDateFormatted = null
      }

      data.groupId = this.$route.params.id
      if (this.$route.params.company != null) {
        data.companyId = this.$route.params.company
      } else {
        data.companyId = this.$store.state.user.data.companyId
      }
      data.filters = this.formFilters
      this.$store.dispatch('searchFormResults', data).then(resp => {
        console.log(resp.forms)
        // resp.forms.forEach(form => {
        //   var user = self.users.find(u => u.id === form.userId)
        //   if (user) {
        //     form.userName = user.firstName + ' ' + user.lastName
        //   }
        //   self.labels.push(label)
        // })
        self.formsResults = resp.forms
        self.totalFormResultRows = resp.forms.length
      })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    prePrintAll () {
      var data = {}

      data.groupId = this.$route.params.id
      if (this.$route.params.company != null) {
        data.companyId = this.$route.params.company
      } else {
        data.companyId = this.$store.state.user.data.companyId
      }
      data.filters = JSON.parse(JSON.stringify(this.formFilters))
      data.filters = JSON.stringify(data.filters)
      console.log('paramss', data)
      window.open(this.$firebase.app().options.functionsHostName + '/downloadFormResults?' + new URLSearchParams(data))

      // var self = this
      // this.hideForForms = true
      // console.log('formsResults', this.formsResults)
      // this.massReportRows = []
      // this.formsResults.forEach(function (item) {
      //   console.log('item', item)
      //   self.showReport(item, true)
      // })
      //
      // this.printFormResults()
      // setTimeout(function () {
      //   // self.reportRows = []
      //   self.formsResultsView = true
      // }, 2000)
    },
    clearResults () {
      this.formFilters.formId = null
      this.formFilters.dateRange = null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OperationForms/FormResults.vue